import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductShareLink, { ProductShareLinkStyles } from "@insite/content-library/Components/ProductShareLink";
import Icon from "@insite/mobius/Icon";
import Img from "@insite/mobius/Img";
import Link from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
});

export interface ProductDetailsShareLinkStyles {
    wrapper?: InjectableCss;
    link?: ProductShareLinkStyles;
    shareIcon?: InjectableCss;
}

export const shareLinkStyles: ProductDetailsShareLinkStyles = {
    wrapper: {
        css: css`
            margin-top: 30px;
            text-align: center;
            display: flex;
        `,
    },
    link: {
        link: {
            css: css`
                text-transform: uppercase;
                line-height: 14px;
                letter-spacing: 0.01em;
                font-weight: 500;
                color: #000;
                margin-right: 5px;
                font-size: 12px;
            `,
        },
    },
    shareIcon: {
        css: css`
            display: flex;
            gap: 7px;
        `,
    },
};

const styles = shareLinkStyles;

const ProductDetailsShareLink: React.FC<Props> = ({ product }) => {
    if (!product) {
        return null;
    }

    const onClickFacbook = () => {
        window.open("http://www.facebook.com/share.php?u=" + encodeURIComponent(location.href));
    };

    const onClickTwitter = () => {
        window.open("https://twitter.com/intent/tweet?text=" + encodeURIComponent(location.href));
    };

    const onClickMail = () => {
        window.open(
            "mailto:?Subject=Check Out This Product At IronValleySupply.com&Body=" +
                "Iron Valley Supply  " +
                encodeURIComponent(location.href),
        );
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <ProductShareLink extendedStyles={styles.link} />
            <StyledWrapper {...styles.shareIcon}>
                <Link onClick={onClickFacbook}>
                    <Img src="/userfiles/favicon-logo/facebook-logo.png" />
                
                </Link>
                <Link onClick={onClickTwitter}>
                    <Img src="/userfiles/favicon-logo/twitter-logo.png" />
                </Link>
                <Link onClick={onClickMail}>
                    <Img src="/userfiles/favicon-logo/mail-logo.png" />
                </Link>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(ProductDetailsShareLink)),
    definition: {
        displayName: "Share Link",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
